<script setup lang="ts">
import { computed } from "vue";

const props = defineProps({
  errorCode: {
    type: Number,
    required: true,
  },
  errorText: {
    type: String
  },
  errorDescription: {
    type: String,
  },
});

const errorText = computed(() => {
  if (props.errorText != null)
    return props.errorText;

  switch (props.errorCode) {
    case 401:
      return "Unauthorized";
    case 403:
      return "Forbidden";
    case 404:
      return "Page Not Found";
    case 500:
    default:
      return "Unexpected error";
  }
});
const errorDescrLocal = computed(() => {
  if (props.errorDescription != null)
    return props.errorDescription;

  switch (props.errorCode) {
    case 403:
      return "You do not have access to this page";
    default:
      return undefined;
  }
});
</script>

<template>
  <div class="l-page__main">
    <div class="not-found">
      <div class="not-found__wrap">
        <div class="not-found__title">
          <h1>{{ props.errorCode }}: {{ errorText }}</h1>
        </div>
        <div class="not-found__text" v-if="errorDescrLocal">{{ errorDescrLocal }}</div>
        <!-- <div class="not-found__button">
          <button class="wds-btn _medium _secondary _center" type="button">← Go Home</button>
        </div> -->
      </div>
    </div>
  </div>
</template>

<style scoped>
.error-block {
  margin: 32px 0;
  text-align: center;
}
</style>